import React from 'react';
import * as Icons from 'lucide-react';
import { Service } from '../types';

interface ServiceCardProps {
  service: Service;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ service }) => {
  const IconComponent = Icons[service.icon as keyof typeof Icons] as React.ComponentType<any>;

  return (
    <div className="bg-white rounded-xl shadow-md hover:shadow-2xl transition-all duration-500 p-6 border border-gray-100 group hover:-translate-y-3 transform animate-fade-in-up relative overflow-hidden">
      {/* Animated background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-green-50 to-teal-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
      
      <div className="relative z-10">
      <div className="flex items-center mb-4">
        <div className="bg-blue-100 p-3 rounded-lg group-hover:bg-green-600 transition-all duration-500 group-hover:scale-110 group-hover:rotate-6">
          <IconComponent className="h-6 w-6 text-green-600 group-hover:text-white transition-colors duration-500" />
        </div>
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors duration-500">
        {service.title}
      </h3>
      <p className="text-gray-600 mb-4 leading-relaxed">
        {service.description}
      </p>
      <ul className="space-y-2">
        {service.features.map((feature, index) => (
          <li key={index} className="flex items-center text-sm text-gray-600 group-hover:text-gray-700 transition-colors duration-300">
            <div className="w-1.5 h-1.5 bg-red-600 rounded-full mr-3 group-hover:animate-pulse"></div>
            {feature}
          </li>
        ))}
      </ul>
      </div>
      
      {/* Hover effect border */}
      <div className="absolute inset-0 border-2 border-green-600 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
    </div>
  );
};

export default ServiceCard;